var render = function render(){var _vm=this,_c=_vm._self._c;return _c('candidate-details-competencies-table',{attrs:{"report_title":_vm.$t('create_campaign.standard_attributes'),"items":_vm.permanent_rating,"fields":_vm.fields,"icon":'mdi mdi-hexagon-multiple',"job_table":false,"max":_vm.max}})
}
var staticRenderFns = []

export { render, staticRenderFns }